<template>
  <div>
    <div class="global-bg" v-if="isShow" @click="isShow = false">
      <div
        class="global"
        @click.stop
        :style="{ height: pdfHeight ? pdfHeight + 'px' : '930px' }"
      >
        <div class="pdfContainer">
          <div class="button">
            <el-button round @click="prev()"
              ><i class="las la-arrow-left iconFont"></i
            ></el-button>

            <el-button round @click="next()"
              ><i class="las la-arrow-right iconFont"></i
            ></el-button>
            <!-- <el-button type="success" @click="scaleD()">放大</el-button>
            <el-button type="success" @click="scaleX()">缩小</el-button> -->

            <el-button round @click="clockwise()"
              ><i class="las la-redo-alt iconFont"></i
            ></el-button>
            <el-button round @click="antiClockwise()"
              ><i class="las la-undo-alt iconFont"></i
            ></el-button>
          </div>
          <el-scrollbar
            :style="{
              height: pdfHeight ? pdfHeight - 130 + 'px' : '800px',
              width: '750px',
            }"
          >
            <div class="pdf">
              <pdf
                ref="pdf"
                :src="src"
                :page="currentPage"
                :rotate="pageRotate"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
                @loaded="loadPdfHandler"
              ></pdf>
            </div>
          </el-scrollbar>
          <div class="page">
            <span class="pageNum">{{ currentPage }}</span>
            <span class="pageNum">/</span>
            <span class="pageNum">{{ pageCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pdf from "vue-pdf";
export default {
  data() {
    return {
      // src: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf", // pdf的路径 实际项目后端返回
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      scale: 100, //  开始的时候默认和容器一样大即宽高都是100%
      pageRotate: 0, // 旋转角度
      isShow: false,
    };
  },
  props: ["src", "pdfHeight"],
  components: { Pdf },
  // props: {
  //   selectedScene: Object, //从父组件传递过来的当前选中的项目item
  // },
  mounted() {
    console.log(Pdf, "Pdf----->>>");
  },
  methods: {
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    //  上一页
    prev() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    // 下一页
    next() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    //放大
    scaleD() {
      if (this.scale == 100) return this.$message.warning("已经是最大喽~~");
      this.scale += 10;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    //缩小
    scaleX() {
      if (this.scale == 40) return this.$message.warning("已经是最小喽~~");
      this.scale += -10;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    // 顺时针
    clockwise() {
      this.pageRotate += 90;
    },
    // 逆时针
    antiClockwise() {
      this.pageRotate -= 90;
    },
  },
};
</script>
<style lang="scss" scoped>
.global {
  position: absolute;
  background: rgb(230, 230, 230);
  padding: 30px;
  z-index: 9;
  width: 800px;
  height: 930px;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  box-shadow: 10px 10px 15px grey;
  border-radius: 6px;
}
.preview {
  width: 100%;
  height: 50px;
}

.pdfContainer {
  width: 100%;
  height: calc(100% + 30px);
}
.pdfContainer .button {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdfContainer .pdf {
  width: 100%;
  // height: 723px;
}
.pdfContainer .page {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pageNum {
  font-size: 18px;
  color: #000;
}
/deep/ .el-scrollbar__wrap {
  overflow-y: auto;
  overflow-x: hidden;
}
.global-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
.iconFont {
  font-size: 18px;
}
/deep/.el-button {
  padding: 11px 12px;
}
</style>
